enum UIErrorMessage {
  FieldRequired = 'This field is required',
  LoadProviderFailed = 'Failed to load provider',
  InvalidEmail = 'Please enter a valid email',
  InvalidPassword = 'Please enter a valid password',
  FailedGoogleAuth = 'Unable to authorise via Google',
  FailedSsoAuth = 'Unable to authorise via SSO.',
  FailedPasswordAuth = 'Failed to login. Either email or password is wrong',
  FailedResetPassword = 'Failed to reset password. Please try again later.',
  FailedLoadForm = 'Failed to load form. Please try again.',
  FormNotChanged = 'Form not updated. Please update to save changes.',
  ProviderAllValidInputs = 'Please provide all valid inputs',
  NoResetPasswordToken = 'Authentication token missing to reset password',
  InvalidTokenResetPassword = 'Reset password failed. Make sure you use the latest reset password link and try again',
  InvalidToken = 'Invalid authentication token passed',
  InvalidCredential = 'Either email or password is incorrect',
  IncorrectCurrentPassword = 'Current password is incorrect',
  AuthFailed = 'Failed to authenticate. Please try again later',
  AuthForbidden = 'Email not registered. Please contact your administrator',
  ActionForbidden = 'Action forbidden. Please contact your administrator',
  PasswordReset = 'You need to reset your password to authenticate',
  ServerError = 'We are not able to complete your request. Please try again.',
  EmailNotVerified = 'Please verify your email',
  InvalidConfirmPassword = `Password doesn't match`,
  InvalidForm = `Please provide all required fields`,
  AddressFieldsMissing = `Please provide missing address fields`,
  AliasFieldsMissing = `Please provide missing alias name fields`,
  InvalidDate = `Invalid date`,
  InvalidNumber = `Should be a number`,
  NumberMustBePositive = `Value cannot be negative`,
  InvalidSsn = 'Invalid SSN number',
  InvalidNpi = 'Invalid NPI number',
  InvalidFilePath = 'Invalid File Path',
  NpiShouldBeNumber = 'NPI number should be numeric',
  InvalidPhoneNumber = 'Invalid phone number',
  MissingProvider = 'Provider data is missing',
  MissingNPI = 'Missing NPI data',
  MissingDea = 'Missing DEA data',
  MissingCertificate = 'Missing Certificate data',
  MissingLicense = 'Missing License data',
  MissingInsurance = 'Missing Liability Insurance data',
  MissingEducation = 'Missing Education data',
  MissingTraining = 'Missing Training data',
  MissingWorkHistory = 'Missing Work History data',
  MissingSanction = 'Missing Sanction data',
  MissingBoard = 'Missing Board data',
  MissingCaqh = 'Missing CAQH data',
  FileSizeRestriction = 'Files over 100 MB cannot be uploaded',
  CouldNotDownloadCsv = 'Could not download CSV',
  SelectOneEntity = 'Please select at least one entity to run verification',
  InvalidTaxID = 'Invalid Tax ID',
  LicenseNotFound = 'License not found',
  ReportInvalidLicense = 'Invalid license received on report generation',
  ReportInvalidBoardCerts = 'Invalid board certification received on report generation',
  BoardCertificationNotFound = 'Board certification not found',
  RequestFailed = 'Unable to process your request',
  InvalidDatasetType = 'Invalid dataset type',
  DatasetScanNotExist = 'Sanction scan not found',
  RemovedPayerPlan = 'Payer plan has already been removed from this group',
  UnknowError = 'Something went wrong',
  DatasetNotEnabled = 'Dataset is disabled for your organization',
  PasswordRequiredToImport = 'Password required to import profile',
  UserNameRequiredToImport = 'Username required to import profile',
  IdRequiredToImport = 'ID required to import profile',
  NpiNotEnabled = 'NPI Verification is not available for your organization. Please contact your admin to activate.',
  CaqhExportNotAvailable = 'CAQH export is not available',
  MonitoringDisabled = 'Monitoring is not enabled. Please contact your administrator',
  BoardCertAlreadyExist = 'Oops! This Board Certification already added',
  NeedsReviewDisclaimer = 'Some items do not match your provided information. Please review and update this record.',
  DeaAlreadyExist = 'Oops! This DEA Registration number already added',
  UnsupportedDateOfBirth = `Invalid DOB. Provider can't be older than the Titanic!`,
  DOBYoungerThanSupported = `Invalid DOB. Provider must be older than 15 years.`,
  ProcessingPreviousRequest = 'We are processing your previous request, Please wait',
  NpdbNotEnabled = 'NPDB is not enabled for your organization. Please contact your administrator.',
  PleaseResolveError = 'Please resolve the error and try export',
  ChecklistProcessing = 'Some of checklist items are still processing, Please wait',
  CvoSameStatusSelected = `The status can't be the same as the current one.`,
  CertificateTypeRequired = 'Certificate type is required to create a Certificate',
  CertificateNumberRequired = 'Certificate number is required to create a Certificate',
  InvalidCertificateForPrint = 'Certificate Info is required to init a Print for certificate',
  CertificateAlreadyExist = 'Oops! This Certificate already added',
  LicenseMonitorAlreadyEnabled = 'It looks like monitoring was already turned on for this license. Please refresh this page to see the latest results.',
  LicenseMonitorRemoved = 'It looks like monitoring was removed for this license. Please refresh this page to see the latest results.',
  DatasetMonitorAlreadyEnabled = 'It looks like monitoring was already turned on for {datasets}. Please refresh this page to see the latest results.',
  DatasetMonitorRemoved = 'It looks like monitoring was removed for {dataset}. Please refresh this page to see the latest results.',
  ChecklistAttachedFileIssue = `There's an issue with a file attached to this checklist. Remove the attached file and try again.`,
  ChecklistInfoOutDate = 'Checklist information may be out of date.',
  NpiRemoved = 'NPI Number has been removed.',
  CvoStatusRequestedIsEmpty = 'The requested CVO status is empty. Not able proceed the request',
  ProfileSourceRecordNotFound = 'Not able to continue the merge, Source record information is required to review the record changes',
  CaqhTargetRecordNotFound = 'Not able to continue the merge, Target record information is required to review the record changes',
  ProfileMergeNotAvailable = 'No provider profile merges are available.',
  ProfileTargetRecordNotFound = `Trying to review the merge record, while the target record is not found`,
  LicenseTypeShouldNotEmpty = 'License Type should not be empty',
  LicenseStateShouldNotEmpty = 'License state should not be empty',
  ProfileRecordIsNotMergeType = 'Merge resolution is not a merge type, Not able to process the record',
  BoardCertTypeShouldNotEmpty = 'Board Certification Type should not be empty',
  InsuranceCoverageTypeShouldNotEmpty = 'Insurance Coverage Type should not be empty',
  EducationSchoolNameShouldNotEmpty = 'School name should not be empty',
  TargetRecordFoundForAddMergeType = 'Failed to load page, Target record is found, this record is no longer add state',
  SourceRecordNotResolved = 'Failed to load page, Record has some unknown value and it is not resolved',
  ProviderDeactivated = 'Provider is deactivated',
  DeaRegistrationShouldNotEmpty = 'DEA Registration Number should not be empty',
  AddressFieldValidationMessage = 'Please provider value for all required fields in address',
  EmailMustNotEmpty = 'Email must not be empty',
  LicenseNumberMustNotEmpty = 'License Number must not be empty',
  EducationEcfmgShouldNotEmpty = 'ECFMG Number must not be empty',
  ServerErrorMessage = 'Oops! Something went wrong. Please try again later',
  FailedToAuthenticate = `Failed to authenticate. Please try again later`,
  AuthenticationExpired = 'Authenticate expired. Please login again',
  CouldNotLogoutCurrentSession = `Couldn't logout current session.`,
  PasswordExpired = 'Password expired. Please try resetting the password.',
  FailedToIdentifyReqOrg = 'Failed to identify requested organization. Please use organization specific URL to login',
  FailedToResetPassword = 'Failed to reset the password.',
  FailedToResetPasswordWithTryAgain = 'Failed to reset the password. Please try again later',
  FailedToResetPasswordWithDetail = 'Failed to reset the password. Make sure you use the latest reset password link and try again',
  FailedToAuthoriseByGoogle = `Failed to authorise using Google. Make sure you're using registered email.`,
  FailedToLoadLoggedDevices = 'Failed to load logged-in devices list.',
  FailedToGetCredGrants = 'Failed to get credentialing granted organizations.',
  FailedToGetCredUsers = 'Failed to load credentialing users.',
  FailedToLoadOrgUsers = 'Failed to load organization users.',
  FailedToCreateProvider = 'Failed to create new provider.',
  PermissionMissingToCreateProvider = 'Missing permission to create provider.',
  FailedToUpdateProvider = 'Failed to update the provider.',
  PermissionMissingToUpdateProvider = 'Missing permission to udpate provider.',
  ProviderNotFound = 'Provider not found.',
  FailedToDeleteProvider = 'Failed to delete provider',
  PermissionMissingToDeleteProvider = 'Missing permission to delete the provider.',
  FailedToGetProvider = 'Failed to get the provider.',
  PermissionMissingToGetProvider = 'Missing permission to get the provider.',
  FailedToGetProviderList = 'Failed to get the provider list.',
  PermissionMissingToGetProviderList = 'Missing permission to get the provider list.',
  FailedToGetProviderTypes = 'Failed to get provider types.',
  PermissionMissingToGetProviderTypes = 'Missing permission to get provider types.',
  FailedToGenerateReportPreview = 'Failed to generate provider profile report.',
  PermissionMissingToGenerateReport = 'Missing permission to generate provider report.',
  FailedToGetProviderProfileInfo = 'Failed to get provider profile information.',
  PermissionMissingToGetProviderProfileInfo = 'Missing permission to get profile profile information.',
  FailedToGetProviderInfos = 'Failed to get provider infos',
  FailedToCreateInfo = 'Failed to create new {0}.',
  FailedToUpdateInfo = 'Failed to update the {0}.',
  FailedToGetList = 'Failed to get the {0} list.',
  FailedToGetInfo = 'Failed to get the {0}',
  FailedToDeleteInfo = 'Failed to delete {0}',
  PermissionMissingToCreateInfo = 'Missing permission to create new {0}.',
  PermissionMissingToUpdateInfo = 'Missing permission to update {0}.',
  PermissionMissingToDeleteInfo = 'Missing permission to delete {0}.',
  PermissionMissingToGetInfo = 'Missing permission to get {0}.',
  PermissionMissingToGetList = 'Missing permission to get {0} list.',
  LicenseNotFoundForProvider = 'License not found for the provider.',
  FailedToAttachLicense = 'Failed to attach a license to the provider.',
  MissingPermissionToAttachLicense = 'Missing permission to attach license to the provider.',
  FailedToGetAllLicenseList = 'Failed to get all licenses for the provider.',
  FailedToGetLicenseVerification = 'Failed to get verification for the license.',
  MissingPermissionToGetLicenseVerification = 'Missing permission to get verification for the license.',
  LicenseVerificationNotFound = 'License Verification not found for the license.',
  FailedToGetAllLicenseVerification = 'Failed to get all verification for the license.',
  MissingPermissionToGetAllLicenseVerification = 'Missing permission to get all verification for the license.',
  FailedToRemoveLicense = 'Failed to remove the license.',
  MissingPermissionToRemoveLicense = 'Missing permission to remove the license.',
  FailedToUpdateLicense = 'Failed to update a license for the provider.',
  MissingPermissionToUpdateLicense = 'Missing permission to update license to the provider.',
  FailedToInitiateLicenseVerification = 'Failed to initiate license verification.',
  MissingPermissionToInitiateLicenseVerification = 'Missing permission to initiate license verification.',
  FailedToResolveLicense = 'Failed to resolve the license verification.',
  MissingPermissionToResolveLicense = 'Missing permission to resolve the license verification.',
  FailedToGetLicenseVerificationDiff = 'Failed to get difference of the license verifications.',
  MissingPermissionToGetLicenseVerificationDiff = 'Missing permission to get difference of the license verifications.',
  MissingPermissionToGetProviderCount = 'Missing permission to get providers count.',
  MissingPermissionToGetLicenseList = 'Missing permission to get license list.',
  FailedToGetLicenseList = 'Failed to get license list.',
  FailedToLoadLicenseCount = 'Failed to load license count for the organization.',
  FailedToGetDatasetMetadata = 'Failed to get dataset metadata.',
  MissingPermissionToGetDatasetMetadata = 'Missing permission to get dataset metadata.',
  FailedToGetDatasetScanParameter = 'Failed to get dataset scan parameter.',
  MissingPermissionToGetDatasetScanParameter = 'Missing permission to get dataset scan parameter',
  FailedToGetDatasetMatchList = 'Failed to get dataset match list.',
  MissingPermissionToGetDatasetMatchList = 'Missing permission to get dataset match list',
  FailedToInitiateDatasetScan = 'Failed to initiate the dataset scan.',
  MissingPermissionToInitiateDatasetScan = 'Missing permission to initiate the dataset scan',
  FailedToGetDatasetScan = 'Failed to get the dataset scan',
  MissingPermissionToGetDatasetScan = 'Missing permission to get the dataset scan',
  FailedToRefreshDatasetScanVerification = 'Failed to refresh the dataset scan verification',
  MissingPermissionToRefreshDatasetScan = 'Missing permission to refresh the dataset scan verification',
  FailedToUpdateDatasetMatch = 'Failed to update the dataset match.',
  MissingPermissionToUpdateDatasetMatch = 'Missing permission to update the dataset match',
  MissingPermissionToGetAlertCount = 'Missing permission to get alert count.',
  FailedToDismissAlert = 'Failed to dismiss the alert.',
  TryingToGetFileFromUnknownFolder = 'Trying to get files from unknown folder.',
  TryingToDeleteUnknownFile = 'Trying to delete unknown file.',
  MissingPermissionToUploadFile = 'Missing permission to upload file.',
  FileAlreadyExistInFolder = 'File already exist within this folder.',
  MissingPermissionToGetFileMetadata = 'Missing permission to get file metadata.',
  TryingToGetUnknownFile = 'Trying to get unknown file.',
  MissingPermissionToDownloadFile = 'Missing permission to download file.',
  TryingToDownloadUnknownFile = 'Trying to download unknown file.',
  FailedToGetProviderForGourp = 'Failed to get the provider list for the group.',
  MissingPermissionToGetProviderForGroup = 'Missing permission to get the provider list for the group.',
  TryingToGetProviderListForUnknownGroup = 'Trying to get the provider list for unknown group.',
  FailedToExportProviderForGourp = 'Failed to export the provider list for the group.',
  MissingPermissionToExportProviderForGroup = 'Missing permission to export the provider list for the group.',
  TryingToExportProviderListForUnknownGroup = 'Trying to export the provider list for unknown group.',
  FailedToExportEnrollmentForGourp = 'Failed to export the enrollments for the group.',
  MissingPermissionToExportEnrollmentForGroup = 'Missing permission to export the enrollments for the group.',
  TryingToExportEnrollmentForUnknownGroup = 'Trying to export the enrollments for unknown group.',
  FailedToUpdatePayerPlanForGourp = 'Failed to update the payer plan for the group.',
  MissingPermissionToUpdatePayerPlanForGroup = 'Missing permission to update the payer plan for the group.',
  TryingToUpdatePayerPlanForUnknownGroup = 'Trying to update the payer plan for unknown group.',
  FailedToUpdateProvidersForGroup = 'Failed to add/remove the providers for the group.',
  MissingPermissionToUpdateProvidersForGroup = 'Missing permission to add/remove the providers for the group.',
  TryingToUpdateProvidersForUnknownGroup = 'Trying to add/remove the providers for unknown group.',
  FailedToAddProviderToPayer = 'Failed to add a provider to payer.',
  MissingPermissionToAddProviderToPayer = 'Missing permission to add a provider to payer.',
  FailedToInitiateProfileImport = 'Failed to initiate the provider profile import.',
  MissingPermissionToInitiateProfileImport = 'Missing permission to initiate a provider profile import.',
  FailedToAttachCredRequestEvent = 'Failed to attach new credentialing request event.',
  MissingPermissionToAttachCredRequestEvent = 'Missing permission to attach new credentialing request event.',
  TryingToAttachCredRequestEventForUnknown = 'Trying to attach the credentialing request event for unknown credentialing request.',
  FailedToUpdateChecklist = 'Failed to update the checklist.',
  MissingPermissionToUpdateChecklist = 'Missing permission to update the checklist.',
  TryingToUpdateChecklistForUnknowCredRequest = 'Trying to update the checklist for unknown credentialing request.',
  FailedToAbortProfileMerge = 'Failed to abort the profile merge.',
  MissingPermissionToAbortProfileMerge = 'Missing permission to abort the profile merge.',
  TryingToAbortUnknownProfileMerge = 'Trying to abort the unknown profile merge.',
  FailedToCommitProfileMerge = 'Failed to commit the profile merge.',
  MissingPermissionToCommitProfileMerge = 'Missing permission to commit the profile merge.',
  TryingToCommitUnknownProfileMerge = 'Trying to commit the unknown profile merge.',
  FailedToConfirmMergeResolution = 'Failed to confirm the merge resolution.',
  MissingPermissionToConfirmMergeResolution = 'Missgin permission to confirm the merge resolution.',
  TryingToConfirmUnknownMergeResolution = 'Trying to confirm uknown merge resolution.',
  MissingPermissionToGetDatasetAggregation = 'Missing permission to get dataset matches count.',
  FailedToGenerateLicenseReport = 'Failed to generate a report, Invalid/ Undefined license data is received',
  FailedToLoadGoogleSiginButton = 'Failed to load Google Sign-in button',
  FileAlreadyExist = 'The file already exists.',
  CannotAddDuplicatedInfo = `Can't add duplicated information. This record already exists`,
  InvalidPrescriptiveAuthority = `Invalid prescriptiveAuthority and/or collaboratingProviderId.`,
  DeaNumberAlreadyRegistered = 'The same DEA number is already registered for the provider',
  ProvidedIncorrectCredential = `You've provided an incorrect credential. Please check it.`,
  NpdbAnotherOneTimeQueryTriggered = 'Another one-time query has already been triggered within the last 24 hours',
  NoProviderSanctionsReportAvailable = 'No Sanctions & Exclusions report available.',
  InvalidSanctionsReportDate = 'Invalid Sanctions & Exclusions report date',
  InvalidSanctionsReportPath = 'Invalid Sanctions & Exclusions report file path',
  BlobNotFound = 'Invalid Blob - Blob is not found',
  AlertAlreadyDismissed = 'Alert is already dismissed',
  SourceNotEnabled = 'Source is not enabled',
  FollowingParametersAreRequired = 'The following parameters are required, but do not have a valid value',
  ContentOrURITooLong = 'Content is too large or URI is too long',
  MergeNotInprogress = 'This merge is not in progress',
  PasswordProtectPdfError = 'This file is encrypted or password-protected and cannot be previewed. Please download the file.',
  InvalidPdfError = 'Invalid PDF. Preview unavailable.',
  InvalidFileType = 'Invalid MIME file type',
  UnsupportedPreviewFileType = 'File type not supported for preview',
  FailedToLoadFile = 'Failed to load the file',
  InvalidBoardForPrint = 'Board Cert Info is required to init a Print for board',
  PrintInvalidEntitytype = 'Invalid entity type passed to print',
  ScanWithIncorrectUserAction = 'Scan with matches have incorrect user action needed',
  ScanFailedAndMoitorDeletedForPrimarySourceIssue = 'Primary source reported an issue. The monitor has been deleted due to: <br /> {0}',
  NoProviderEnrollmentsAvailable = 'No Enrollments report available.',
  InvalidEnrollmentsReportDate = 'Invalid Enrollments report date',
  InvalidEnrollmentsReportPath = 'Invalid Enrollments report file path',
  NoExpirableCredentialsReport = 'Expirable Credentials report data is empty',
  InvalidExpirableCredReportDate = 'Invalid Expirable Credentials report date',
  InvalidExpirableCredReportPath = 'Invalid Expirable Credentials report file path',
  NoRosterReport = 'Roster report data is empty',
  InvalidRosterReportDate = 'Invalid Roster report date',
  InvalidRosterReportPath = 'Invalid Roster report file path',
  InvalidOrgFound = 'Invalid Organization Found',
  AmaImportDataNotFound = 'AMA Profile import data is not found',
  AmaExportNotAvailable = 'AMA export is not available',
  AmaDatasetIsDisabled = `AMA dataest is not enabled for you organization. It is required for to start a merge. Please contact your administrator`,
  FailedToGetProviderSanctionMonitoringList = 'Failed to get the provider sanctions monitoring list.',
  PermissionMissingToGetProviderSanctionMonitoringList = 'Missing permission to get the provider sanctions monitoring list.',
  ProviderSanctionMonitoringListNotFound = 'Provider sanctions monitoring list not found',
  MissingPermissionToGetProviderSanctionsMonitoringCount = 'Missing permission to get providers santions monitoring count.',
  MissingMedicaidEnrollment = 'Missing Medicaid Enrollment',
  NpdbEnrollmentFailed = `NPDB enrollment failed to connect because provider information doesn't match.`,
  FailedToAuthoriseBySso = `We couldn't log you in with SSO. Please make sure your account is registered.`,
  NoOAuthConfig = 'Configuration not found',
  MissingCodeParameter = 'Missing code parameter',
  CaqhImportDataNotFound = 'CAQH Profile import data is not found',
  LoggedUserInfoNotFound = 'Logged user info was not found'
}

export default UIErrorMessage;
